<template>
    <div class="kgr-tableWrapper">
        <table class="kgr-table kgr-table--block">
            <thead>
                <tr class="kgr-table__row">
                    <th
                        v-for="(weekday, weekdayIndex) in weekdays"
                        style="min-width: 200px"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ $t(`weekday_${weekdayIndex + 1}`) }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr class="kgr-table__row kgr-table__row--top">
                    <td
                        v-for="weekday in weekdays"
                        class="kgr-table__cell"
                    >
                        <div
                            v-for="(element, i) in events[weekday]"
                            :key="`${weekday}_${i}_${index}`"
                            class="kgr-postfix kgr-postfix--gutters kgr-postfix--center kgr-row"
                        >
                            <div class="kgr-postfix__fixed kgr-postfix__fixed--noShrink">
                                <kgr-time-range-picker
                                    :start="element && element.start ? element.start.toString() : null"
                                    :end="element && element.end ? element.end.toString() : null"
                                    @change="updateTime($event, weekday, i)"
                                    @errorStateChanged="updateErrorState($event, weekday, i, weekday, i)"
                                />
                            </div>
                            <div class="kgr-postfix__fixed kgr-postfix__fixed--noShrink">
                                <a @click="removeEvent(weekday, i)">
                                    <kgr-icon icon-class="delete" />
                                </a>
                            </div>
                        </div>
                        <div
                            v-if="overlappingError[weekday]"
                            class="kgr-color--error kgr-row"
                        >
                            {{ $t('Einträge dürfen sich nicht überschneiden.') }}
                        </div>
                        <button
                            type="button"
                            class="kgr-button"
                            @click="addEvent(weekday)"
                        >
                            {{ $t('add') }}
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import Icon from '../common/icon/Icon.vue';
import Time from '../../js/date/Time';
import TimeRange from '../../js/date/TimeRange';
import TimeRangePicker from '../common/form/picker/TimeRangePicker.vue';

export default {
    name: 'KindergartenEmployeeRegularTimeForm',
    components: {
        'kgr-time-range-picker': TimeRangePicker,
        'kgr-icon': Icon,
    },
    data() {
        return {
            index: 0,
            events: {
                monday: [],
                tuesday: [],
                wednesday: [],
                thursday: [],
                friday: [],
                saturday: [],
                sunday: [],
            },
            errors: {
                monday: [],
                tuesday: [],
                wednesday: [],
                thursday: [],
                friday: [],
                saturday: [],
                sunday: [],
            },
            overlappingError: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
            },
            weekdays: [
                'monday',
                'tuesday',
                'wednesday',
                'thursday',
                'friday',
                'saturday',
                'sunday',
            ],
        };
    },
    computed: {
        key() {
            return `eventScheduleWeekly_eventScheduleWeeklys_${this.index}_events`;
        },
    },
    watch: {
        index() {
            this.updateEvents();
        },
    },
    mounted() {
        window.addEventListener('regular-time-row-changed', (e) => {
            this.index = e.detail;
            this.updateEvents();
            this.update();
        });
        const highlightedRow = $('tr.is-highlight');
        if (highlightedRow.length) {
            this.index = highlightedRow.data('form-index');
            this.updateEvents();
            this.update();
        }
    },
    methods: {
        updateTime(timeRange, weekday, index) {
            this.events[weekday][index] = timeRange;
            this.overlappingError[weekday] = this.events[weekday].some((event, eventIndex) => {
                if (eventIndex === index) {
                    return false;
                }

                return event.overlaps(timeRange);
            });
            this.dispatchErrorState();
            this.update();
        },
        addEvent(weekday) {
            this.events[weekday].push(null);
            this.update();
        },
        removeEvent(weekday, index) {
            this.events[weekday].splice(index, 1);
            this.update();
            this.updateErrorState(false, weekday, index);
        },
        update() {
            const data = [];
            for (const weekday of this.weekdays) {
                this.events[weekday].filter((event) => event && event.start && event.end).map((event) => {
                    return {
                        start: `1970-01-${this.getWeekday(weekday)} ${event.start.toString()}`,
                        end: `1970-01-${this.getWeekday(weekday)} ${event.end.toString()}`,
                        type: 'employee',
                        minutes: event.diffInMinutes(),
                    };
                }).forEach((event) => data.push(event));
            }

            const eventHolderNote = document.getElementById(this.key);
            if (eventHolderNote) {
                eventHolderNote.value = JSON.stringify(data);
                const minutes = data.map((event) => event.minutes).reduce((a, b) => a + b, 0);
                window.dispatchEvent(new CustomEvent('minutesChanged', { detail: minutes }));
            }
        },
        getWeekday(weekday) {
            switch (weekday) {
                case 'monday':
                    return '05';
                case 'tuesday':
                    return '06';
                case 'wednesday':
                    return '07';
                case 'thursday':
                    return '08';
                case 'friday':
                    return '09';
                case 'saturday':
                    return '10';
                case 'sunday':
                    return '11';
            }
        },
        updateEvents() {
            const events = document.getElementById(this.key) ? JSON.parse(document.getElementById(this.key).value) : [];
            this.events = {
                monday: [],
                tuesday: [],
                wednesday: [],
                thursday: [],
                friday: [],
                saturday: [],
                sunday: [],
            };
            events.forEach((event) => {
                const start = new Date(event.start);
                const end = new Date(event.end);
                const timeRange = new TimeRange(new Time(start.getHours(), start.getMinutes()), new Time(end.getHours(), end.getMinutes()));
                this.events[this.weekdays[start.getDay() - 1]].push(timeRange);
            });
        },
        updateErrorState(hasErrors, weekday, index) {
            this.errors[weekday][index] = hasErrors;
            this.dispatchErrorState(weekday);
        },
        dispatchErrorState() {
            const hasTimeRangeErrors = this.weekdays.map((weekday) => this.errors[weekday].some((hasErrors) => hasErrors)).some((hasErrors) => hasErrors);
            const hasOverlappingErrors = this.weekdays.map((weekday) => this.overlappingError[weekday]).some((hasErrors) => hasErrors);
            window.dispatchEvent(new CustomEvent('errorStateChanged', { detail: hasTimeRangeErrors || hasOverlappingErrors }));
        },
    },
};
</script>
